import { PhysicalAssetType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { BeneficiariesAllocationDto } from 'service/dto/general.dto';
import {
  AssignBeneficiaryDto,
  PhysicalAsset,
  PhysicalAssets
} from 'service/dto/physical-asset.dto';
import { errorHandler } from 'utils';

class PhysicalAssetService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createPhysicalAsset = async (physicalAssetType: PhysicalAssetType) => {
    try {
      const response = await this.baseService.post(
        '/physical-asset/create',
        physicalAssetType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
  getPhysicalAssets = async (): Promise<PhysicalAssets> => {
    try {
      const response = await this.baseService.get('/physical-asset');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deletePhysicalAsset = async (assetId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/physical-asset/${assetId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBeneficiary = async (assignBeneficiaryDto: AssignBeneficiaryDto) => {
    try {
      const response = await this.baseService.patch(
        '/physical-asset/assign-to-beneficiary',
        assignBeneficiaryDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getPhysicalAsset = async (assetId: number): Promise<PhysicalAsset> => {
    try {
      const response = await this.baseService.get(`/physical-asset/${assetId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  unAssignPhysicalAssetBeneficiary = async (
    allocationId?: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/physical-asset/unassign-beneficiary/${allocationId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  editBulkPhysicalAssetBeneficiary = async (
    beneficiariesAllocationDto?: BeneficiariesAllocationDto
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch(
        `/physical-asset/bulk-edit-beneficiary-assign`,
        beneficiariesAllocationDto
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  removePhysicalTrustee = async (
    assetId: number,
    trusteeId: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/physical-asset/unassign-trustee/${assetId}/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignPhysicalTrustee = async (
    assetId: number[],
    trusteeId: number,
    note: string
  ): Promise<void> => {
    try {
      const response = await this.baseService.put(
        `/physical-asset/assign/bulk-trustee`,
        {
          assetId,
          trusteeId,
          note
        }
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default PhysicalAssetService;
